import React, { Component } from "react";

import PropTypes from "prop-types";
import { cleanIputText } from "../../../utils/functions";
import Search from "../../../shared/custom-components/search";
import Client from "../../../../../static/images/find-institution.svg";
import ErrorIcon from "../../../../../static/images/error-icon.svg";
import { withTranslation } from "react-i18next";

export class SearchUser extends Component {
  constructor(props) {
    super(props);
    this.state = { searchValue: "" };
  }

  handlerChange = (event) => {
    if (event.key == "Enter") this.searchAction();
    this.setState({
      searchValue: cleanIputText(event.target.type, event.target.value),
    });
  };

  searchAction = () => {
    if (this.state.searchValue != "") {
      return this.props.findUserByCode(this.state.searchValue);
    }
    return false;
  };

  render() {
    const userMsgs = this.props.t("searchUser", { returnObjects: true });

    return (
      <div className="main-backoffice userbac">
        <img src={Client} className="clientImage" />
        <p className="welcome">{userMsgs.title}</p>
        <p className="client">{userMsgs.subtitle}:</p>
        <div className="line red"></div>
        <Search
          id="search-field"
          name="searchValue"
          placeholder={userMsgs.placeholder}
          className="Input__input Search__input"
          onChange={this.handlerChange}
          onSearchClick={this.searchAction}
          onKeyDown={this.handlerChange}
          value={this.state.searchValue}
        />
        {this.props.errorInSearch === true && (
          <div id="select-2-error" className="error">
            <span className="error__icon">
              <img src={ErrorIcon} alt="Error" />
            </span>
            <div className="error__text">{userMsgs.error}</div>
          </div>
        )}
      </div>
    );
  }
}

SearchUser.propTypes = {
  findUserByCode: PropTypes.func.isRequired,
};

export default withTranslation()(SearchUser);
